import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Coverage',
    href: '#coverage'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy/95 backdrop-blur-md shadow-lg py-3' : 'bg-transparent py-5'}`} data-id="element-353" data-mp="1px9rqnzta0jx">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-354" data-mp="9nfx4j1zn6tf">
        <div className="flex justify-between items-center" data-id="element-355" data-mp="enkeebaq05kp">
          {/* Logo */}
          <a href="#home" className="flex flex-col items-start group" data-id="element-356" data-mp="epdo5zgmr5wx">
            <img src="https://cdn.magicpatterns.com/uploads/bD3v9AavBa4gaqpbXra7Xw/Logo_Jet_Foce.png" alt="JetForce Aerospace" className="h-10 sm:h-12 object-contain transition-transform group-hover:scale-105" data-id="element-357" data-mp="jn6quiiq5hsg" />
            <span className="text-gold text-xs font-medium tracking-widest mt-1 hidden sm:block uppercase" data-id="element-358" data-mp="3s1nsf7e90tqj">
              Aviation Services
            </span>
          </a>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-359" data-mp="5n4bp41sx2gw">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-slate-300 hover:text-gold transition-colors text-sm font-medium uppercase tracking-wider" data-id="element-360" data-mp="34bthwwhejh9g">
                {link.name}
              </a>)}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center space-x-6" data-id="element-361" data-mp="2wbwviye2e4jk">
            <a href="tel:+17862620064" className="flex items-center text-white hover:text-gold transition-colors group" data-id="element-362" data-mp="3b1cnuit8ui1d">
              <Phone className="w-4 h-4 mr-2 text-gold group-hover:animate-pulse" data-id="element-363" data-mp="2icfex6ax9xla" />
              <span className="font-heading tracking-wide" data-id="element-364" data-mp="2iei5brfzlsqj">
                +1 786-262-0064
              </span>
            </a>
            <a href="#contact" className="bg-gold hover:bg-gold-light text-navy font-bold py-2.5 px-6 rounded-full transition-all shadow-gold-glow hover:shadow-gold-glow-lg transform hover:-translate-y-0.5" data-id="element-365" data-mp="2sabqfz7ruujx">
              Request a Quote
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-366" data-mp="2krgt7k69z0w">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-white hover:text-gold transition-colors p-2" data-id="element-367" data-mp="a4950y8d3d3s">
              {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-368" data-mp="14vxib3ssylp" /> : <Menu className="w-6 h-6" data-id="element-369" data-mp="16gmzmb99rcp" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Accordion */}
      <AnimatePresence data-id="element-370" data-mp="swl51ebjm2ar">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-navy-light border-t border-white/10 overflow-hidden" data-id="element-371" data-mp="xu3ini0i95p3">
            <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-372" data-mp="1gkuoi9laadyq">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="block px-3 py-4 text-base font-medium text-white hover:text-gold hover:bg-white/5 rounded-md transition-colors border-b border-white/5 uppercase tracking-wider" data-id="element-373" data-mp="3p1xf5b9xv2ct">
                  {link.name}
                </a>)}
              <div className="pt-6 flex flex-col space-y-4 px-3" data-id="element-374" data-mp="bnk8ejtzdsxl">
                <a href="tel:+17862620064" className="flex items-center text-white justify-center py-2" data-id="element-375" data-mp="bovb0gbowun4">
                  <Phone className="w-5 h-5 mr-2 text-gold" data-id="element-376" data-mp="1vwmeyg7143i" />
                  <span className="font-heading text-lg tracking-wide" data-id="element-377" data-mp="3u19wjgi1jh80">
                    +1 786-262-0064
                  </span>
                </a>
                <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="bg-gold text-navy font-bold py-3 px-6 rounded-full text-center transition-all shadow-gold-glow" data-id="element-378" data-mp="uetjgxjegpra">
                  Request a Quote
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}